import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PackageResumeDesktop } from '@packages/entities/package-resume';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { AppFacade } from '@app/app.facade';
import { FlightType } from '@search-bar/entities/flight-type';
import { sectorFlightsMapper } from '@flight-results/mappers/flights.mapper';
import { getFlightItemPackage, hasAirSelectedCompleteDesktop } from '@packages/packages-result/mappers/package-resume.mapper';
import { DesktopSector, FlightItem, FlightResultDesktop, Option } from '@app/entities/flight-results';

@Pipe({
  name: 'packageResumeDesktop',
  standalone: false
})
export class PackageResumeDesktopPipe implements PipeTransform {

  constructor(
    private facade: AppFacade
  ) { }

  transform(airSelected: FlightResultDesktop, hotelSelected: HotelSearched): Observable<PackageResumeDesktop> {
    return this.facade.searchData$.pipe(map(searchData => {
      const flightType = searchData.flightType as FlightType;
      const isOneWay = flightType === FlightType.ONEWAY;
      if (this.hasAirSelected(airSelected)) {
        const departureSector = {
          ...airSelected.Sectors[0],
          Flights: sectorFlightsMapper(airSelected.Sectors[0].Options[0].Flights)
        };
        const optionItem = departureSector.Options[0];
        const flightsLength = optionItem.Flights.length;
        if (isOneWay) {
          return {
            OneWay: isOneWay,
            CompleteAirSelected: airSelected,
            HotelSeleted: {
              Hotel: hotelSelected,
              Checkin: hotelSelected.CheckinDate,
              Checkout: hotelSelected.CheckoutDate,
              Rooms: hotelSelected.Rooms,
              RoomRates: hotelSelected.RoomRates,
              DestinationName: hotelSelected.Destination
            },
            Price: airSelected.Price,
            Going: {
              SectorNumber: departureSector.SectorNumber,
              Flights: optionItem.Flights,
              FlightItem: this.getFlightItem(optionItem, departureSector, flightsLength),
              TotalDuration: optionItem.TotalDuration
            }
          };
        } else {
          const arrivalSector = {
            ...airSelected.Sectors[airSelected.Sectors.length - 1],
            Flights: sectorFlightsMapper(airSelected.Sectors[airSelected.Sectors.length - 1].Options[0].Flights)
          };
          const optionItemArrival = arrivalSector.Options[0];
          const flightsLengthArrival = optionItemArrival.Flights.length;
          return {
            OneWay: isOneWay,
            CompleteAirSelected: airSelected,
            HotelSeleted: {
              Hotel: hotelSelected,
              Checkin: hotelSelected.CheckinDate,
              Checkout: hotelSelected.CheckoutDate,
              Rooms: hotelSelected.Rooms,
              RoomRates: hotelSelected.RoomRates,
              DestinationName: hotelSelected.Destination
            },
            Price: airSelected.Price,
            Going: {
              SectorNumber: departureSector.SectorNumber,
              Flights: optionItem.Flights,
              FlightItem: this.getFlightItem(optionItem, departureSector, flightsLength),
              TotalDuration: optionItem.TotalDuration
            },
            Return: {
              SectorNumber: arrivalSector.SectorNumber,
              Flights: optionItemArrival.Flights,
              FlightItem: this.getFlightItem(optionItemArrival, arrivalSector, flightsLengthArrival),
              TotalDuration: optionItemArrival.TotalDuration
            }
          };
        }
      } else {
        return {
          OneWay: isOneWay,
          CompleteAirSelected: null,
          HotelSeleted: {
            Hotel: hotelSelected,
            Checkin: hotelSelected.CheckinDate,
            Checkout: hotelSelected.CheckoutDate,
            Rooms: hotelSelected.Rooms,
            RoomRates: hotelSelected.RoomRates,
            DestinationName: hotelSelected.Destination
          },
          Price: null
        };
      }
    }));
  }

  private getFlightItem(optionItem: Option, sector: DesktopSector, flightsLength: number): FlightItem {
    return getFlightItemPackage(optionItem, sector, flightsLength);
  }

  private hasAirSelected(airSelected: FlightResultDesktop): boolean {
    return hasAirSelectedCompleteDesktop(airSelected);
  }

}
